import {APP} from 'jsAssets/constants/app';
import _u from "jsAssets/utils/index";
import _uc from "jsAssets/utils/checkout";

const state = {
    dataWasLoaded: false,
    checkoutData: null,
    deliveryBranchIds: {},
    editingBasket: false,
    deliveryCourier: {},
}

const getters = {
    dataWasLoaded: state => state.dataWasLoaded,
    checkoutData: state => state.checkoutData,
    deliveryBranchIds: state => state.deliveryBranchIds,
    editingBasket: state => state.editingBasket,
    deliveryCourier: state => state.deliveryCourier,
}

const actions = {
    getOrderData ({ commit }, orderId) {
        let params = {
            'handler': 'checkout',
            'func': 'showOrder',
            'ORDER_ID': orderId,
            'test': 'yes' // @todo Отладка. Не забыть отключить
        }
        commit('app/setLoadingData', true, { root: true });
        _u.requestHttp('get', APP.ajax_endpoint, params, (responseData) => {
            commit('setCheckoutData', responseData.data.data);
            commit('app/setSelectedCity', responseData.data.data.city, { root: true });
            commit('setDataWasLoaded', true);
            commit('app/setLoadingData', false, { root: true });
        });
    },

    getCheckoutData ({ commit }) {
        let params = {
            'handler': 'checkout',
            'func': 'getCheckoutData',
            'test': 'yes' // @todo Отладка. Не забыть отключить
        }
        commit('app/setLoadingData', true, { root: true });
        _u.requestHttp('get', APP.ajax_endpoint, params, (responseData) => {
            commit('setCheckoutData', responseData.data.data);
            if(responseData.data.status != 'error'){
                commit('app/setSelectedCity', responseData.data.data.city, { root: true });
                commit('setDataWasLoaded', true);
                commit('app/setLoadingData', false, { root: true });
            } else {
                commit('app/setLoadingData', false, { root: true });
            }
        });
    },

    submitCheckout ({ commit }, payload) {
        let params = {
            'handler': 'checkout',
            'func': 'submitCheckout',
            'params': payload.params,
            'test': 'yes' // @todo Отладка. Не забыть отключить
        }
        commit('app/setLoadingData', true, { root: true });
        _u.requestHttp('post', APP.ajax_endpoint, params, (responseData) => {
            commit('setCheckoutData', responseData.data.data);
            if (responseData.data.data.redirect) {
                _u.redirect(responseData.data.data.redirect);
            }
            commit('app/setLoadingData', false, { root: true });
        });
    },

    applyBonuses ({ commit }, payload) {
        let params = {
            'handler': 'checkout',
            'func': 'applyBonuses',
            'orderId': payload.orderId,
            'bonuses': payload.bonuses,
            'params': payload.params,
            'test': 'yes' // @todo Отладка. Не забыть отключить
        }
        commit('app/setLoadingData', true, { root: true });
        _u.requestHttp('post', APP.ajax_endpoint, params, (responseData) => {
            commit('setCheckoutData', responseData.data.data);
            commit('app/setLoadingData', false, { root: true });
        });
    },

    cancelBonuses ({ commit }, payload) {
        let params = {
            'handler': 'checkout',
            'func': 'cancelBonuses',
            'orderId': payload.orderId,
            'bonuses': payload.bonuses,
            'params': payload.params,
            'test': 'yes' // @todo Отладка. Не забыть отключить
        }
        commit('app/setLoadingData', true, { root: true });
        _u.requestHttp('post', APP.ajax_endpoint, params, (responseData) => {
            commit('setCheckoutData', responseData.data.data);
            commit('app/setLoadingData', false, { root: true });
        });
    },

    applyPromoCode ({ commit, state }, payload) {
        let params = {
            'handler': 'checkout',
            'func': 'applyPromoCode',
            'promoCode': payload.promoCode,
            'params': payload.params,
            'test': 'yes' // @todo Отладка. Не забыть отключить
        }

        commit('app/setLoadingData', true, { root: true });
        _u.requestHttp('post', APP.ajax_endpoint, params, (responseData) => {
            commit('setCheckoutData', responseData.data.data);
            commit('app/setLoadingData', false, { root: true });
        });
    },

    clearPromoCode ({ commit }, payload) {
        let params = {
            'handler': 'checkout',
            'func': 'clearPromoCode',
            'params': payload.params,
            'test': 'yes' // @todo Отладка. Не забыть отключить
        }
        commit('app/setLoadingData', true, { root: true });
        _u.requestHttp('post', APP.ajax_endpoint, params, (responseData) => {
            commit('setCheckoutData', responseData.data.data);
            commit('app/setLoadingData', false, { root: true });
        });
    },

    requestBonusCard ({ commit }, payload) {
        console.log('z5', payload);
        let params = {
            'handler': 'checkout',
            'func': 'requestBonusCard',
            'orderId': payload.orderId,
            'phone': payload.phone,
            'params': payload.params,
            'test': 'yes' // @todo Отладка. Не забыть отключить
        }
        commit('app/setLoadingData', true, { root: true });
        _u.requestHttp('post', APP.ajax_endpoint, params, (responseData) => {
            commit('setCheckoutData', responseData.data.data);
            commit('app/setLoadingData', false, { root: true });
        });
    },

    assignBonusCard ({ commit }, payload) {
        let params = {
            'handler': 'checkout',
            'func': 'assignBonusCard',
            'orderId': payload.orderId,
            'phone': payload.phone,
            'bonusCard': payload.bonusCard,
            'smsCode': payload.smsCode,
            'params': payload.params,
            'test': 'yes' // @todo Отладка. Не забыть отключить
        }
        commit('app/setLoadingData', true, { root: true });
        _u.requestHttp('post', APP.ajax_endpoint, params, (responseData) => {
            commit('setCheckoutData', responseData.data.data);
            commit('app/setLoadingData', false, { root: true });
        });
    },

    selectGroupPaymentService ({ commit }, payload) {
        let params = {
            'handler': 'checkout',
            'func': 'selectGroupPaymentService',
            'orderId': payload.orderId,
            'groupPaymentId': payload.groupId,
            'params': payload.params,
            'test': 'yes' // @todo Отладка. Не забыть отключить
        }
        commit('app/setLoadingData', true, { root: true });
        _u.requestHttp('post', APP.ajax_endpoint, params, (responseData) => {
            commit('setCheckoutData', responseData.data.data);
            commit('app/setLoadingData', false, { root: true });
        });
    },

    selectPaymentService ({ commit }, payload) {
        let params = {
            'handler': 'checkout',
            'func': 'selectPaymentService',
            'orderId': payload.orderId,
            'paymentId': payload.paymentId,
            'params': payload.params,
            'test': 'yes' // @todo Отладка. Не забыть отключить
        }
        commit('app/setLoadingData', true, { root: true });
        _u.requestHttp('post', APP.ajax_endpoint, params, (responseData) => {
            commit('setCheckoutData', responseData.data.data);
            commit('app/setLoadingData', false, { root: true });
        });
    },

    selectDeliveryService ({ commit }, payload) {
        let params = {
            'handler': 'checkout',
            'func': 'selectDeliveryService',
            'orderId': payload.orderId,
            'deliveryId': payload.deliveryId,
            'params': payload.params,
            'test': 'yes' // @todo Отладка. Не забыть отключить
        }
        commit('app/setLoadingData', true, { root: true });
        _u.requestHttp('post', APP.ajax_endpoint, params, (responseData) => {
            commit('setCheckoutData', responseData.data.data);
            commit('app/setLoadingData', false, { root: true });
        });
    },

    selectDeliveryCity ({ commit }, payload) {
        let params = {
            'handler': 'checkout',
            'func': 'globalChangeTown',
            'orderId': payload.orderId,
            'deliveryId': payload.deliveryId,
            'cityId': payload.cityId,
            'params': payload.params,
            'test': 'yes' // @todo Отладка. Не забыть отключить
        }
        commit('app/setLoadingData', true, { root: true });
        _u.requestHttp('post', APP.ajax_endpoint, params, (responseData) => {
            commit('setCheckoutData', responseData.data.data);
            commit('app/setSelectedCity', responseData.data.data.city, { root: true });
            commit('app/setLoadingData', false, { root: true });
        });
    },

    selectCourierService ({ commit }, payload) {
        let params = {
            'handler': 'checkout',
            'func': 'selectCourierService',
            'orderId': payload.orderId,
            'courierServiceId': payload.courierServiceId,
            'params': payload.params,
            'test': 'yes' // @todo Отладка. Не забыть отключить
        }
        commit('app/setLoadingData', true, { root: true });
        _u.requestHttp('post', APP.ajax_endpoint, params, (responseData) => {
            commit('setCheckoutData', responseData.data.data);
            commit('app/setLoadingData', false, { root: true });
        });
    },

    selectDeliveryBranch ({ commit }, payload) {
        let params = {
            'handler': 'checkout',
            'func': payload.func,
            'orderId': payload.orderId,
            'deliveryId': payload.deliveryId,
            'cityId': payload.cityId,
            'deliveryBranchIds': payload.deliveryBranchIds,
            'params': payload.params,
            'test': 'yes' // @todo Отладка. Не забыть отключить
        }
        commit('app/setLoadingData', true, { root: true });
        _u.requestHttp('post', APP.ajax_endpoint, params, (responseData) => {
            commit('setCheckoutData', responseData.data.data);
            commit('app/setLoadingData', false, { root: true });
        });
    },

    deleteBasketItem ({ commit }, payload) {
        let params = {
            'handler': 'checkout',
            'func': 'deleteBasketItem',
            'basketId': payload.basketId,
            'params': payload.params,
            'test': 'yes' // @todo Отладка. Не забыть отключить
        }
        commit('app/setLoadingData', true, { root: true });
        _u.requestHttp('post', APP.ajax_endpoint, params, (responseData) => {
            commit('setCheckoutData', responseData.data.data);
            commit('app/setLoadingData', false, { root: true });
        });
    },

    updateBasketItem ({ commit }, payload) {
        let params = {
            'handler': 'checkout',
            'func': 'updateBasketItem',
            'basketId': payload.basketId,
            'quantity':  payload.quantity,
            'params': payload.params,
            'test': 'yes' // @todo Отладка. Не забыть отключить
        }
        commit('app/setLoadingData', true, { root: true });
        _u.requestHttp('post', APP.ajax_endpoint, params, (responseData) => {
            commit('setCheckoutData', responseData.data.data);
            commit('app/setLoadingData', false, { root: true });
        });
    },

}

const mutations = {
    setDataWasLoaded (state, dataWasLoaded) {
        state.dataWasLoaded = dataWasLoaded;
    },
    setCheckoutData (state, checkoutData) {
        state.checkoutData = checkoutData;
    },
    setDeliveryBranchId (state, payload) {
        let deliveryBranchId = _.assign({}, state.deliveryBranchIds);
        deliveryBranchId[payload.orderId] = payload.branchId;
        state.deliveryBranchIds = deliveryBranchId;
    },
    setEditingBasket (state, editingBasket) {
        state.editingBasket = editingBasket;
    },
    setDeliveryCourier (state, payload) {
        let deliveryCourier = _.assign({}, state.deliveryCourier);
        deliveryCourier[payload.orderId] = payload.params;
        state.deliveryCourier = deliveryCourier;
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
